// extracted by mini-css-extract-plugin
export var tile = "item-module--tile--2X1VA";
export var inner = "item-module--inner--16S8l";
export var iconItem = "item-module--iconItem--1HOkJ";
export var title = "item-module--title--8S2T7";
export var description = "item-module--description--1uGHG";
export var iconArrow = "item-module--iconArrow--2OOKG";